// extracted by mini-css-extract-plugin
export default {"videoElement":"index_videoElement__8Tpyn","loading":"index_loading__hf11O","error":"index_error__OfJlY"};